
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Use a separate function to delay non-critical operations
const startApp = () => {
  const root = document.getElementById("root")!;
  
  // Clean any loading indicator
  if (root.firstChild) {
    root.innerHTML = '';
  }
  
  createRoot(root).render(<App />);
};

// Start the app based on browser environment
if (typeof window !== 'undefined') {
  if ('requestIdleCallback' in window) {
    // TypeScript doesn't recognize requestIdleCallback natively
    (window as any).requestIdleCallback(startApp);
  } else {
    // Use a proper type assertion for window to fix the TypeScript error
    (window as Window).addEventListener('load', startApp);
  }
} else {
  // Server-side rendering path
  startApp();
}
